import { render, staticRenderFns } from "./ChangeNameDialog.vue?vue&type=template&id=5abc90f4&scoped=true"
import script from "./ChangeNameDialog.vue?vue&type=script&lang=js"
export * from "./ChangeNameDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeNameDialog.vue?vue&type=style&index=0&id=5abc90f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abc90f4",
  null
  
)

export default component.exports